import { render, staticRenderFns } from "./CmgAccountModalLegalCopy.vue?vue&type=template&id=6d925c50&scoped=true&lang=pug"
import script from "./cmg-account-modal-legal-copy.ts?vue&type=script&lang=ts&external"
export * from "./cmg-account-modal-legal-copy.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgAccountModalLegalCopy.vue?vue&type=style&index=0&id=6d925c50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d925c50",
  null
  
)

export default component.exports